import { render, staticRenderFns } from "./CustomRouterLink.vue?vue&type=template&id=43a9ca00&"
import script from "./CustomRouterLink.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomRouterLink.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports